import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../../loader-button/LoaderButton';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

const SummaryModal = ({
  isReadOnly,
  modalOpen,
  setModalOpen,
  handleSave,
  isLoading,
  vendorLabel,
  vendorId,
  validated,
  setValidated,
  isAddingCredentials,
  syncOnly,
  setSyncOnly,
  handleValidationError,
  allRequired,
  isUpdated
}) => {
  const modalClick = () => {
    setModalOpen(!modalOpen);
    setValidated(null);
  };

  const toggleSync = () => {
    setSyncOnly(!syncOnly);
  };

  return (
    <Fragment>
      <Button
        color="falcon-primary"
        onClick={() => modalClick()}
        data-testid={'save-changes-btn'}
        disabled={isAddingCredentials || isReadOnly || !allRequired || !isUpdated}
      >
        Save changes
      </Button>
      <Modal isOpen={modalOpen} toggle={e => toggleSync(e)}>
        <ModalHeader>Save Confirmation</ModalHeader>
        <ModalBody>
          <p>
            You are about to update all settings for {vendorLabel}. Changes to default filters will only apply to new
            added Managed Products, not your existing{' '}
            <Link to={`/vendors/${vendorId}/products`}>Managed Products.</Link>
          </p>
          <p>
            Check the 'Sync Only' box if you would like to create and configure Managed Products without running the
            service.
          </p>
          <div className="flex text-right mr-2">
            <Input type="checkbox" checked={syncOnly} className="mt-2" onChange={e => setSyncOnly(!syncOnly)} />
            <small>Sync Only</small>
          </div>
        </ModalBody>
        <ModalFooter>
          {validated === false ? (
            <>
              <p className="text-danger">
                Please check required credentials, filtering and default config settings are properly set.
              </p>
              <Button color="falcon-danger" onClick={() => handleValidationError()}>
                Update settings
              </Button>
            </>
          ) : (
            <>
              <Button color="falcon-danger" onClick={() => setModalOpen(!modalOpen)}>
                Cancel
              </Button>
              <LoaderButton
                color="falcon-primary"
                onClick={handleSave}
                isLoading={isLoading}
                name="save-and-add"
                data-testid={'save-confirmation-btn'}
              >
                Save changes
              </LoaderButton>
            </>
          )}
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

SummaryModal.propTypes = {
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  validated: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleSave: PropTypes.func,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  setValidated: PropTypes.func,
  isAddingCredentials: PropTypes.bool,
  syncOnly: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  handleValidationError: PropTypes.func,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool
};

export default SummaryModal;
